import SystemFieldProto from '../proto/system-field-proto';


export default class TaskIdField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.TASK_ID;
    }

    get sortHintMessage() {
        return 'Sort by task id #';
    }

    getCsvValue(item) {
        return item.shortId;
    }

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => i.type === 'task' ? parseInt(i.item.shortId) : 0,
            ],
            directions: [sort]
        }
    }
}